<template>

  <!-- Финансовые показатели -->
  <values-blocks :blocks="['act']"></values-blocks>

  <!-- Заголовок -->
  <h1 class="mb-4 pl-4">{{ $route.meta.title }}</h1>

  <!-- Список документов -->
  <div class="block">
    <table-component :list="list" type="docs">
      <tr>
        <th class="w-48">Дата</th>
        <th class="w-48">Оплата</th>
        <th class="w-48">Акт</th>
        <th>Статус</th>
      </tr>
    </table-component>
  </div>

</template>

<script>
import { useDocsStore } from '@/stores/docs'
import { mapState } from 'pinia/dist/pinia'

import TableComponent from '@/components/table/TableComponent'
import Helper from '@/classes/helper'
import { useFinStore } from '@/stores/fin'
import ValuesBlocks from '@/components/ValuesBlocks'

export default {
  name: 'DocsList',
  components: {
    ValuesBlocks,
    TableComponent,
  },
  data () {
    return {
      filterStatus: null,
      loading: false,
    }
  },
  computed: {
    ...mapState(useDocsStore, ['list', 'statusList']),
    ...mapState(useFinStore, ['balance', 'withOutActs']),
  },
  methods: {
    toCurrency: Helper.toCurrency,
    async fetchOrders () {
      this.loading = true
      //this.$store.dispatch('useTasksStore/getData')
      this.loading = false
    },
  },
  mounted () {

  },
}
</script>
